import React from "react";
import Label from "components/FormElements/Label";
import * as TextMetaProperty from "./TextMetaProperty";
import * as CheckboxMetaProperty from "./CheckboxMetaProperty";
import * as PrintonlyMetaProperty from "./PrintonlyMetaProperty";
import * as LongtextMetaProperty from "./LongtextMetaProperty";
import * as SecuretextMetaProperty from "./SecuretextMetaProperty";
import * as RichtextMetaProperty from "./RichtextMetaProperty";
import * as EditortextMetaProperty from "./EditortextMetaProperty";
import * as RelatedcontentMetaProperty from "./RelatedcontentMetaProperty";
import * as DateMetaProperty from "./DateMetaProperty";
import * as DatetimeMetaProperty from "./DatetimeMetaProperty";
import * as SelectentryMetaProperty from "./SelectentryMetaProperty";
import * as FileMetaProperty from "./FileMetaProperty";
import * as RelatedentriesMetaProperty from "./RelatedentriesMetaProperty";
import * as JsonMetaProperty from "./JsonMetaProperty";
import * as AuthorsMetaProperty from "./AuthorsMetaProperty";
import * as TagsMetaProperty from "./TagsMetaProperty";
import * as FieldlistMetaProperty from "./FieldlistMetaProperty";
import { Field, FieldArray, useFormikContext } from "formik";
import SelectBox from "components/FormElements/SelectBox";
import FastTextInput from "components/FormElements/FastTextInput";
import { TrashIcon } from "@heroicons/react/outline";
import SecondaryButton from "components/Buttons/SecondaryButton";
// import SelectentryMetaProperty from "./SelectentryMetaProperty";

export const metaProperties = {
    AuthorsMetaProperty,
    CheckboxMetaProperty,
    RelatedcontentMetaProperty,
    DateMetaProperty,
    DatetimeMetaProperty,
    EditortextMetaProperty,
    SecuretextMetaProperty,
    FieldlistMetaProperty,
    FileMetaProperty,
    JsonMetaProperty,
    PrintonlyMetaProperty,
    RichtextMetaProperty,
    SelectentryMetaProperty,
    RelatedentriesMetaProperty,
    LongtextMetaProperty,
    TextMetaProperty,
    TagsMetaProperty,
};

export const getMetaField = function (type, props) {
    if (metaProperties[type]) {
        return React.createElement(
            metaProperties[type].Property
                ? metaProperties[type].Property
                : metaProperties[type],
            props
        );
    }

    return null;
};

export default function MetaProperty(props) {
    const { type, value, field, label, nameMask, initialValue, metaProps } =
        props;
    if (!field || !type) {
        return null;
    }

    const name = (nameMask ? nameMask : "{field}").replace("{field}", field);
    const MetaField = getMetaField(type, {
        field: field,
        name: name,
        type: type,
        value: value,
        initialValue: initialValue,
        metaProps: metaProps ? metaProps : [],
    });

    if (!MetaField) {
        return (
            <div className="text-red-600">
                <Label>{label}</Label>
                {type} : {field} : {label} : {value}
            </div>
        );
    }

    return (
        <div className={type === "PrintonlyMetaProperty" ? "hidden" : ""}>
            <Label>{label}</Label>
            {MetaField}
        </div>
    );
}

export function MetaPropertyField(props) {
    // needs to return uuid, label, type, props (as [])
    const { values } = useFormikContext();

    return (
        <FieldArray name="meta">
            {(arrayHelpers) => (
                <div className="space-y-6 pb-40">
                    {values.meta.map((meta, index) => (
                        <div key={index}>
                            {meta.uuid && (
                                <Field
                                    name={`meta[${index}].uuid`}
                                    className="hidden"
                                />
                            )}
                            <div className="grid grid-cols-7 items-end gap-4">
                                <div className="col-span-3">
                                    {index === 0 && <Label>Label</Label>}
                                    <FastTextInput
                                        name={`meta[${index}].label`}
                                        placeholder="Label"
                                    />
                                </div>
                                <div className="col-span-4">
                                    {index === 0 && <Label>Type</Label>}
                                    <div className="flex items-end gap-2">
                                        <div className="flex-grow">
                                            <SelectBox
                                                options={Object.keys(
                                                    metaProperties
                                                ).map((key) => {
                                                    return {
                                                        value: key,
                                                        label: metaProperties[
                                                            key
                                                        ].Label,
                                                    };
                                                })}
                                                name={`meta[${index}].type`}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() =>
                                                arrayHelpers.remove(index)
                                            }
                                        >
                                            <TrashIcon className="mb-2 h-4 w-4" />
                                            <span className="sr-only">
                                                Remove Field
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="mr-6">
                                {metaProperties[meta.type].Configure &&
                                    React.createElement(
                                        metaProperties[meta.type].Configure,
                                        {
                                            fieldName: `meta[${index}].props`,
                                            propertyInfo: meta,
                                            index: index,
                                        }
                                    )}
                            </div>
                        </div>
                    ))}
                    <SecondaryButton
                        type="button"
                        onClick={() =>
                            arrayHelpers.push({
                                label: "",
                                uuid: null,
                                type: "TextMetaProperty",
                            })
                        }
                    >
                        Add Field
                    </SecondaryButton>
                </div>
            )}
        </FieldArray>
    );

    // return (
    //     <div>
    //         {channel?.meta.map((metaProp, index) => (
    //             <div key={index}>
    //                 <FastTextInput name={`meta[${index}]["uuid"]`} />
    //                 <FastTextInput name={`meta[${index}]["label"]`} />
    //                 <FastTextInput name={`meta[${index}]["type"]`} />
    //             </div>
    //         ))}
    //     </div>
    // );
}
